export default __webpack_public_path__ + "static/design-6a37987a360ab2b7171f4654c8bf10c6.png";